import { Injectable } from '@angular/core';
import { CanLoad, Route, Router, UrlSegment } from '@angular/router';
import { CompaniesApiService } from '@fleet-beat/api';
import { CompanyDto } from '@fleet-beat/core';
import { AuthService, CompanyStoreService } from '@fleet-beat/shared';
import { catchError, map, Observable, of, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CompanyCanLoadGuard implements CanLoad {
  constructor(
    private api: CompaniesApiService,
    private auth: AuthService,
    private store: CompanyStoreService,
    private router: Router,
  ) {}

  canLoad(route: Route, segments: UrlSegment[]): Observable<boolean> {
    if (!this.auth.authenticated) {
      this.router.navigate(['/']);
      return of(false);
    }
    const companyId = segments[0]?.path;

    if (!companyId) {
      this.auth.signOut();
      return of(false);
    }

    return this.api.getOne(companyId, this.auth.authHeaders).pipe(
      tap((company: CompanyDto) => {
        if (company) this.store.setCompany(company);
      }),
      map(() => true),
      catchError(() => {
        this.auth.signOut();
        return of(false);
      }),
    );
  }
}
